import React from "react";
import { Navigate } from "react-router-dom";
import Clients from "../Pages/Superadmin/Clients";
import SuperadminLogin from "../Pages/Superadmin/Clients/SuperadminLogin";
// =============================
// Public Routes
// =============================

const publicRoutes = [

    {
        path:"/login",
        component:<SuperadminLogin/>
    }
];

// =============================
// Protected Routes
// =============================

const authProtectedRoutes = [

    {
        path:"/",
        component:<Navigate to="/clients" replace />
    },
    {
        path:"/clients",
        component:<Clients/>
    }
];
export {
    publicRoutes,
    authProtectedRoutes
};